export const MIN_ENCODER_DEBOUNCE_MS = 250;
export const MAX_ENCODER_DEBOUNCE_MS = 1_000;
export const ENCODER_DEBOUNCE_MULTIPLIER = 1.33;

export function encoderDebounceMs(executionMs: number) {
  if (!Number.isFinite(executionMs) || executionMs < 0) return MIN_ENCODER_DEBOUNCE_MS;
  return Math.min(
    MAX_ENCODER_DEBOUNCE_MS,
    Math.max(MIN_ENCODER_DEBOUNCE_MS, Math.round(executionMs * ENCODER_DEBOUNCE_MULTIPLIER)),
  );
}
